import { Link } from "react-router-dom";
import { LuChevronDown, LuShieldCheck, LuCircleCheck, LuLock } from "react-icons/lu";
import SeoHead  from "../components/SeoHead";
import getRelatedPages from "../utils/getRelatedPages";

export default function ConverterLanding({ data }) {
  const { title, hero, slug, faqs, lang } = data;


const softwareSchema = data.tool && {
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  "name": title,
  "operatingSystem": "Web",
  "applicationCategory": "DeveloperApplication",
  "description": data.meta || hero,
  "url": data.toolUrl || `https://edi-converter.de/${slug}`,
  "image": data.image || "/demo-poster.jpg",
  "offers": {
    "@type": "Offer",
    "price": "0",
    "priceCurrency": "EUR"
  }
};





return (
  <>
    <SeoHead
      title={title}
      description={data.meta || hero}
      lang={lang}
      ogImage={`https://edi-converter.de${data.image || "/demo-poster.jpg"}`}
      faqs={faqs}
    />

    {softwareSchema && (
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(softwareSchema) }}
      />
    )}

    {/* Hero */}
    <section className="hero">
      <div className="container hero-grid">
        <div>
          <span className="badge"><LuLock size={13} aria-hidden="true" />100 % lokal im Browser · kostenlos</span>
          <h1 className="h1" style={{ marginTop: 18, fontSize: "clamp(2rem, 4.2vw, 2.9rem)" }}>{title}</h1>
          <p className="lead">{hero}</p>
          <div className="hero-actions">
            <Link to="/edi-konverter" className="btn btn-primary btn-lg">
              EDIFACT-Datei jetzt umwandeln
            </Link>
          </div>
          <div className="hero-trust">
            <span><LuCircleCheck size={16} aria-hidden="true" />Keine Registrierung</span>
            <span><LuCircleCheck size={16} aria-hidden="true" />Kein Server-Upload</span>
            <span><LuCircleCheck size={16} aria-hidden="true" />Kostenlos</span>
          </div>
        </div>

        <div className="card" style={{ padding: 12, borderRadius: "var(--radius-xl)", boxShadow: "var(--shadow-lg)" }}>
          <img
            src={data.image || "/demo-poster.jpg"}
            alt={
              data.alt ||
              `Screenshot des ${data.title || "EDIFACT-Konverters"} im Browser`
            }
            style={{ display: "block", width: "100%", height: "auto", borderRadius: "var(--radius)" }}
            loading="lazy"
            onError={e => {
              // Fehlendes Bild → einmalig auf das Standardbild ausweichen
              if (e.currentTarget.dataset.fallback) return;
              e.currentTarget.dataset.fallback = "1";
              e.currentTarget.src = "/demo-poster.jpg";
            }}
          />
        </div>
      </div>
    </section>

    <section className="section">
      <div className="container container-sm">
        {/* Hinweis-Banner */}
        <div className="alert alert-info">
          <LuShieldCheck size={20} aria-hidden="true" />
          <p>
            <span className="alert-title">Datenschutz und Nutzungshinweis: </span>
            Die Verarbeitung erfolgt ausschließlich lokal im Browser. Es werden keinerlei Daten übertragen oder gespeichert.
            Dieses Tool ist nur für unkritische Test- und Lerndaten gedacht.
            Bitte keine Firmen-, personenbezogenen oder sensiblen Daten hochladen.
          </p>
        </div>

        {/* Content Section */}
        {data.content?.length > 0 && (
          <div className="prose" style={{ marginTop: 48 }}>
            {data.content.map((block, index) => (
              <div key={index}>
                <h2>{block.heading}</h2>
                <p>{block.text}</p>
              </div>
            ))}
          </div>
        )}

        {/* FAQ Section */}
        {faqs?.length > 0 && (
          <div style={{ marginTop: 56 }}>
            <h2 className="h2" style={{ marginBottom: 20 }}>Häufige&nbsp;Fragen</h2>
            <div className="faq">
              {faqs.map((f, i) => (
                <details key={i}>
                  <summary>
                    {f.q}
                    <LuChevronDown size={18} aria-hidden="true" />
                  </summary>
                  <div className="faq-a">{f.a}</div>
                </details>
              ))}
            </div>
          </div>
        )}

        {/* Weitere Formate */}
        <div style={{ marginTop: 56 }}>
          <h3 className="h3" style={{ marginBottom: 14 }}>Weitere&nbsp;Formate&nbsp;&amp;&nbsp;Typen</h3>
          <ul className="row" style={{ listStyle: "none", padding: 0, margin: 0, gap: 10 }}>
            {getRelatedPages(slug).map(p => (
              <li key={p.slug}>
                <Link to={`/${p.slug}`} className="pill-link">
                  {p.title.split(" –")[0]}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  </>
);
}
